import { render, staticRenderFns } from "./diyLive.vue?vue&type=template&id=f545fd22&scoped=true"
import script from "./diyLive.vue?vue&type=script&lang=js"
export * from "./diyLive.vue?vue&type=script&lang=js"
import style0 from "./diyLive.vue?vue&type=style&index=0&id=f545fd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f545fd22",
  null
  
)

export default component.exports